export default __webpack_public_path__ + "static/mobile-bg-catalog-menu-5f6c686ee060a9c8f01cc99b194f9f73.png";